import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {
  AppDeleteButton,
  AppEditButton,
} from '../../buttons/app-button/AppButton';
import { useStyles } from './AppBarWithActionButtons.styles';

interface IAppBarWithActionButtonsProps {
  editLabel?: string;
  deleteLabel?: string;
  position?: 'start' | 'center' | 'end';
  onEditClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onDeleteClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const justifyContentPosition = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
};

export function AppBarWithActionButtons(props: IAppBarWithActionButtonsProps) {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    editLabel = t('common.edit'),
    deleteLabel = t('common.delete'),
    onEditClick,
    onDeleteClick,
    position = 'start',
  } = props;

  return (
    <Box
      className={classes.buttonsWrapper}
      justifyContent={justifyContentPosition[position]}>
      {onEditClick && (
        <AppEditButton onClick={onEditClick}>{editLabel}</AppEditButton>
      )}
      {onDeleteClick && (
        <AppDeleteButton onClick={onDeleteClick}>{deleteLabel}</AppDeleteButton>
      )}
    </Box>
  );
}
